import { render, staticRenderFns, recyclableRender, components } from "./cart.vue?vue&type=template&id=0f00adf4&scoped=true&"
var renderjs
import script from "./cart.vue?vue&type=script&lang=js&"
export * from "./cart.vue?vue&type=script&lang=js&"
import style0 from "./cart.vue?vue&type=style&index=0&id=0f00adf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f00adf4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/cart/cart.vue"
export default component.exports